/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-20 15:00:10
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-26 22:39:13
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/UploadModal/config.ts
 */
export const filterConfig = (
  data,
  { getI18n },
  type?: 'Image' | 'Video' | 'Both',
) => [
  {
    type: 'selection',
    name: getI18n('general.type'),
    data:
      type === 'Both'
        ? [
            { key: 'Image', name: getI18n('general.tools_helper.image') },
            { key: 'Video', name: getI18n('general.tools_helper.video') },
          ]
        : [
            { key: 'Image', name: getI18n('general.tools_helper.image') },
            { key: 'Video', name: getI18n('general.tools_helper.video') },
          ].filter(({ key }) => !type || type === key),
  },
  {
    type: 'selection',
    name: getI18n('general.hOCTitle.tags'),
    data,
  },
];
